import './App.css';
import HurrydleTable from './components/HurrydleTable';
import Timer from "./components/Timer";
import Keyboard from 'react-simple-keyboard';
import AllWords from './data/all-words.json';
import EasyWords from './data/easy-words.json';
import 'react-simple-keyboard/build/css/index.css';
import { useMemo, useState, useRef, useCallback, useEffect } from "react";
import { Modal, Button, Toast, ToastContainer } from "react-bootstrap";

const App = () => {
  // Setup defaults
  let defaultRows = [];
  let defaultGuessCount = 0;
  let defaultSeconds = 0;

  // First check if today has already been logged
  const todayString = localStorage.getItem("today");
  let todayDone = useRef(false);
  if (todayString !== undefined && todayString !== null) {
    let todayJson = JSON.parse(todayString);
    let myDate = new Date();
    const myStringDate = myDate.getDate() + "-" + (myDate.getMonth() + 1) + "-" + myDate.getFullYear();
    // Check if today is actually today and update if it isn't
    if (todayJson.date === myStringDate) {
      todayDone.current = true;
      // Update rows to reflect finished state
      defaultRows = todayJson.hurrydleRows;
      defaultGuessCount = todayJson.guessCount;
      defaultSeconds = todayJson.seconds;
    }
  }

  const [hurrydleWordOfDay, setHurrydleWordOfDay] = useState(["H", "U", "R", "R", "Y"]);
  useMemo(() => {
    let myWordOfDay = [];
    [...EasyWords[getMyDailyNumber()]].forEach((letter) => myWordOfDay.push(letter.toUpperCase()));
    setHurrydleWordOfDay(myWordOfDay);
  }, []);

  // Track guessed row state
  const [hurrydleRows, setHurrydleRows] = useState(defaultRows);
  // Track Current row state
  const [letterArray, setLetterArray] = useState([]);
  // Track Guessed Blank Letters
  const [blankLetters, setBlankLetters] = useState(" ");
  // Track Guessed Yellow Letters
  const [yellowLetters, setYellowLetters] = useState(" ");
  // Track Guessed Green Letters
  const [greenLetters, setGreenLetters] = useState(" ");

  // Timer stuff
  const [isTimerActive, setIsTimerActive] = useState(false);
  function startTimer() {
    setIsTimerActive(true);
  }

  function stopTimer() {
    setIsTimerActive(false);
  }
  // Guess count
  const [guessCount, setGuessCount] = useState(defaultGuessCount);

  // Success modal
  const [showSuccess, setShowSuccess] = useState(false);
  // Stats modal
  const [showStats, setShowStats] = useState(false);
  // Settings modal
  const [showSettings, setShowSettings] = useState(false);
  // Help modal
  const [showHelp, setShowHelp] = useState(false);  
  // Speedle Toast
  const [showToast, setShowToast] = useState(false);
  // Scroll anchor
  const scrollRef = useRef(null);

  const keyHandler = useCallback((input) => {
    function updateGuessCount() {
      let tempCount = guessCount;
      tempCount++;
      setGuessCount(tempCount);
    }

    // If today has already been guessed we will disable keyboard input
    if (!todayDone.current) {
      // Clone and update array before updating state
      if (input === "{bksp}" || input === "Backspace") {
        let clonedArray = letterArray.slice();
        clonedArray.pop();
        setLetterArray(clonedArray);
      } else if (letterArray.length === 5 && (input === "{enter}" || input === "Enter")) {
        // Only allow a valid word to be guessed
        let stringGuess = "";
        letterArray.forEach((l) => {
          stringGuess += l.toLowerCase();
        });

        if (AllWords.indexOf(stringGuess) > -1) {
          let clonedHurrydleRows = hurrydleRows.slice();
          clonedHurrydleRows.push(letterArray);
          setHurrydleRows(clonedHurrydleRows);
          // Clear out current letters
          setLetterArray([]);

          // Check if guess is a match and stop timer
          let wodlIndex = 0;
          let incorrectGuess = false;
          hurrydleWordOfDay.forEach((wodl) => {
            if (wodl !== letterArray[wodlIndex]) {
              incorrectGuess = true;
            } 
            wodlIndex++;
          });

          // Update guess count
          updateGuessCount();

          if (incorrectGuess === false) {
            stopTimer();
            setShowSuccess(true);
            todayDone.current = true;
          } else {
            // Start the timer
            startTimer();
          }
        } else {
          setShowToast(true);
        }
        // Make sure the current word being guessed has been scrolled into view
        scrollRef.current.scrollIntoView();
      } else if (letterArray.length < 5 && input.length === 1 && (/[a-zA-Z]/).test(input)) {
        let clonedArray = letterArray.slice();
        clonedArray.push(input.toUpperCase());
        setLetterArray(clonedArray);
      }
    }
  }, [hurrydleRows, hurrydleWordOfDay, letterArray, guessCount]);

  // handle what happens on key press so physical keyboards can be used
  const handleKeyPress = useCallback((event) => {
    keyHandler(event.key);
  }, [keyHandler]);

  useEffect(() => {
    // attach the event listener
    document.addEventListener('keydown', handleKeyPress);

    // remove the event listener
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [handleKeyPress]);
  

  return (
    <>
      <div className="App-settings">
        <div className="App-settings-btn" onClick={() => setShowStats(true)}>📊</div>
        {/*<div className="App-settings-btn" onClick={() => setShowSettings(true)}>⚙️</div>*/}
        <div className="App-settings-btn" onClick={() => setShowHelp(true)}>❓</div>
      </div>
      <div className="App">
        <div className="App-header">
          <header className="speedle-font">
            <span className="time-green">speed</span><span className="time-yellow">l</span><span className="time-red">e</span>
          </header>
          <p><span className="time-green">a speed running word game</span></p>
        </div>
        <div className="App-main">
          <div className="App-hurrydle">
            <HurrydleTable
              wordOfDay={ hurrydleWordOfDay }
              letterArray={ letterArray }
              hurrydleRows={ hurrydleRows }
              blankLetters={ blankLetters }
              setBlankLetters={ setBlankLetters }
              greenLetters={ greenLetters }
              setGreenLetters={ setGreenLetters }
              yellowLetters={ yellowLetters }
              setYellowLetters={ setYellowLetters }
            />
          </div>
          <div ref={scrollRef} className="anchor"></div>
        </div>
        <div className="App-secondary">
          <Timer 
              defaultSeconds={ defaultSeconds }
              isActive={ isTimerActive }
              showSuccess={ showSuccess }
              setCloseSuccess={() => setShowSuccess(false)}
              guessCount={ guessCount }
              hurrydleRows={ hurrydleRows }
            />
          <div className="App-keyboard">
            <Keyboard
              onKeyPress={keyHandler}
              theme={"hg-theme-default hg-layout-default myTheme"}
              layout={{
                default: [
                  "Q W E R T Y U I O P",
                  "A S D F G H J K L",
                  "{enter} Z X C V B N M {bksp}"
                ]
              }}
              display={{
                "{bksp}": "⌫",
                "{enter}": "ENTER",
              }}
              buttonTheme={[
                {
                  class: "hg-blank",
                  buttons: blankLetters
                },
                {
                  class: "hg-yellow",
                  buttons: yellowLetters
                },
                {
                  class: "hg-green",
                  buttons: greenLetters
                },
              ]}
            />
          </div>
        </div>
        <footer className="App-footer">
          <a  hidden={ isTimerActive ? true : "" } className="App-link" href="https://paulpeters.me">Crafted with ☕ by Paul Peters</a>
        </footer>
        <MyStatsModal
          show={showStats}
          closeStats={() => setShowStats(false)}
        />
        <MySettingsModal
          show={showSettings}
          closeSettings={() => setShowSettings(false)}
        />
        <MyHelpModal
          show={showHelp}
          closeHelp={() => setShowHelp(false)}
        />
        <ToastContainer className="p-3" position={"middle-center"}>
          <Toast 
            onClose={() => setShowToast(false)} 
            show={showToast} 
            delay={1000} 
            autohide
            bg={"warning"}
          >
            <Toast.Body>
              <strong>Invalid word</strong>
            </Toast.Body>
          </Toast>
        </ToastContainer>
      </div>
    </>
  );
}

export default App;

function MyStatsModal({show, closeStats}) {
  // Date setup 
  let myDate = new Date();
  const myStringDate = myDate.getDate() + "-" + (myDate.getMonth() + 1) + "-" + myDate.getFullYear();

  // Get today stats if available
  const todayString = localStorage.getItem("today");
  let todayJson = todayString !== undefined && todayString !== null ? JSON.parse(todayString) : undefined;
  let myTodayText = "In progress...";
  if (todayJson !== undefined && todayJson.date === myStringDate) {
    myTodayText = "⚡ " + todayJson.seconds + " seconds ⚡ and ❓ " + todayJson.guessCount + " guesses ❓"
      + " with a" + ((todayJson.seconds * todayJson.guessCount) === 0 ? " PERFECT" : "") +" Speedle score => " + (todayJson.seconds * todayJson.guessCount);
  }
  // Get all stats if available
  const statsString = localStorage.getItem("myStats");
  // let statsJson = statsString !== undefined ? JSON.parse(statsString) : undefined;
  
  return (
    <Modal
      show={show}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton onHide={closeStats} className="modal-share">
        <Modal.Title>
        📊 Stats 📊
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-share">
        <p>
          <b>Today's Stats:</b> {myTodayText}
        </p>
        <p>
          <b>Your Stats:</b> 
          <br/><span className="time-yellow">This view will change, but here is a printout of your tracked stats: </span>
          {statsString !== null ? "" + statsString : "No available stats"}
        </p>
      </Modal.Body>
    </Modal>
  );
}

function MySettingsModal({show, closeSettings}) {
  return (
    <Modal
      show={show}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton onHide={closeSettings} className="modal-share">
        <Modal.Title>
        🎉 Settings 🎉
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-share">
        <p>
          Some Settings
        </p>
        <Button variant="success" onClick={() => alert("hello")}>SHARE 💌</Button>
      </Modal.Body>
    </Modal>
  );
}

function MyHelpModal({show, closeHelp}) {
  return (
    <Modal
      show={show}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton onHide={closeHelp} className="modal-share">
        <Modal.Title>
        ❓ Help ❓
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-share">
        <p>
        <span className="speedle-font"><span className="time-green">speed</span><span className="time-yellow">l</span><span className="time-red">e</span></span> is a variation of the popular game <b>Wordle</b>.
        </p>
        <div className="hurrydle-letters-help">
          <p>
            <span className="time-yellow">YELLOW</span> indicates the letter is found in the word but in the wrong location, while the lack of Color indicates the letter does not belong.
            <br/> 
            <span className="hurrydle-yellow">H</span><span className="">E</span><span className="">L</span><span className="">L</span><span className="hurrydle-yellow">O</span>
          </p>
        </div>
        <div className="hurrydle-letters-help">
          <p>
            <span className="time-green">GREEN</span> indicates the letter is in the correct location (all 5 green and you have guessed the word).
            <br/> 
            <span className="hurrydle-green">T</span><span className="hurrydle-green">H</span><span className="hurrydle-yellow">O</span><span className="hurrydle-yellow">R</span><span className="">N</span>
          </p>
        </div>
        <p>
        The <b>main focus</b> of this word game is time and precision, this will cause you to shift your standard word-game strategy of slow and frugal to rash and calculated. 
        </p>
        <p>
          Your <span className="speedle-font"><span className="time-green">speed</span><span className="time-yellow">l</span><span className="time-red">e</span></span> <b>score</b> is a combination of time and guesses. And like golf ⛳ the lower the score, the better.
        </p>
        <p>
        ⚡ Each day a <b>new word</b> is available to be speed run ⚡
        <br/>
        <span className="time-yellow">More features, updates and twists to come...</span>
        </p>
        <Button variant="success" onClick={closeHelp}>Got it 👍</Button>
      </Modal.Body>
    </Modal>
  );
}

function getMyDailyNumber(wordListLength = 100, scramble = false) {
  const now = new Date();
  const start = new Date(now.getFullYear(), 0, 0);
  const diff = (now - start) + ((start.getTimezoneOffset() - now.getTimezoneOffset()) * 60 * 1000);
  const oneDay = 1000 * 60 * 60 * 24;
  const dayOfYear = Math.floor(diff / oneDay);
  if (scramble) {
    const dayNumber = dayOfYear * now.getFullYear();
    // Ensure this number is not higher than total word list length
    return dayNumber % wordListLength;
  }
  // Note this was implemented on the 140th day of the year
  return dayOfYear;
}